import { TTimezone } from '../types'

const getTimezone = () => {
  let timezone: TTimezone = ''
  if (typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search)
    timezone = (searchParams.get('timezone') as TTimezone) || (localStorage.getItem('rangeBenchmark') as TTimezone)
  }
  return timezone
}

export default getTimezone
